export default __webpack_public_path__ + "static/media/login-illustration.f0593a65.svg";